import { SimActiveStateWidget } from './ActiveState/SimActiveStateWidget';
import {
  GridLayout,
  GridLayoutHalfWidthItem,
  GridLayoutItem,
  GridSmallItem,
} from 'src/common/components/Layouts/GridLayout/GridLayout';
import { SimSubscriptionStatusChartWidget } from './SubscriptionStatus/SimSubscriptionStatusChartWidget';
import { SimUsageChartWidget } from './Usage/SimUsageChartWidget';

export const SimProductsGraphs = () => {
  return (
    <GridLayout>
      <GridLayoutItem key="simubscriptionStatus" data-testid="simubscriptionStatus">
        <SimSubscriptionStatusChartWidget />
      </GridLayoutItem>
      <GridSmallItem key="simActiveStateChart" data-testid="simActiveStateChart">
        <SimActiveStateWidget />
      </GridSmallItem>
      <GridLayoutHalfWidthItem key="simUsageChart" data-testid="simUsageChart">
        <SimUsageChartWidget />
      </GridLayoutHalfWidthItem>
    </GridLayout>
  );
};
